/**
 * Smarte product gallery — mobile stage + thumbnail switching
 */

class SmarteProductGallery {
  constructor(root) {
    this.root = root;
    this.viewer = root.querySelector('[id^="GalleryViewer-"]');
    this.thumbs = root.querySelector('[id^="GalleryThumbnails-"]');
    if (!this.viewer || !this.thumbs) return;

    this.slides = Array.from(this.viewer.querySelectorAll('.smarte-product-gallery__stage-item'));
    this.thumbButtons = Array.from(this.thumbs.querySelectorAll('.smarte-product-gallery__thumb'));

    this.thumbs.addEventListener('click', this.onThumbClick.bind(this));
    this.bindSetActiveMedia();
  }

  bindSetActiveMedia() {
    if (this.root.setActiveMediaBound) return;
    this.root.setActiveMediaBound = true;

    const original = this.root.setActiveMedia?.bind(this.root);
    this.root.setActiveMedia = (mediaId, prepend) => {
      if (original) original(mediaId, prepend);
      this.activateByMediaId(mediaId);
    };
  }

  onThumbClick(event) {
    const button = event.target.closest('.smarte-product-gallery__thumb');
    if (!button) return;

    const mediaId = button.dataset.target;
    const panelId = button.dataset.galleryPanel;

    if (mediaId) {
      this.root.setActiveMedia?.(mediaId, false);
      this.activateByMediaId(mediaId);
      return;
    }

    if (panelId) {
      this.activateByPanel(panelId);
    }
  }

  activateByMediaId(mediaId) {
    const slide = this.slides.find((item) => item.dataset.mediaId === mediaId);
    if (!slide) return;
    this.setActiveSlide(slide, mediaId, null);
  }

  activateByPanel(panelId) {
    const slide = this.slides.find((item) => item.dataset.galleryPanel === panelId);
    if (!slide) return;
    this.setActiveSlide(slide, null, panelId);
  }

  setActiveSlide(activeSlide, mediaId, panelId) {
    this.slides.forEach((slide) => {
      const isActive = slide === activeSlide;
      slide.classList.toggle('is-active', isActive);
      slide.toggleAttribute('hidden', !isActive);
    });

    this.thumbButtons.forEach((button) => {
      const isActive =
        (mediaId && button.dataset.target === mediaId) ||
        (panelId && button.dataset.galleryPanel === panelId);
      button.classList.toggle('is-active', isActive);
      button.toggleAttribute('aria-current', isActive);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('media-gallery.smarte-product-gallery').forEach((root) => {
    new SmarteProductGallery(root);
  });
});

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll?.('media-gallery.smarte-product-gallery')?.forEach((root) => {
    new SmarteProductGallery(root);
  });
});
